/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBooks} from '@fortawesome/pro-duotone-svg-icons';

const ResourcesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBooks} {...props} />
);

export default ResourcesIcon;
